import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "shared/components/Modal";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";

const Delete = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const DELETE = t("DELETE", { returnObjects: true });
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () =>
    navigate(SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.LIST.path);

  const [deleteDocumentTemplate] = useMutation(
    graphql.mutations.DELETE_DOCUMENT_TEMPLATE,
    {
      refetchQueries: [
        {
          query: graphql.queries.DOCUMENT_TEMPLATES,
          awaitRefetchQueries: true,
        },
      ],
      onCompleted: () => {
        setVisible(false);
        navigate(SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.LIST.path, {
          replace: true,
        });
      },
    },
  );

  return (
    <Modal
      okText={DELETE.OK}
      cancelText={DELETE.CANCEL}
      onCancel={cancel}
      onOk={() => deleteDocumentTemplate({ variables: { where: { id } } })}
      message={DELETE.MESSAGE}
      visible={visible}
    />
  );
};

export default Delete;
